export default __webpack_public_path__ + "static/media/horseshoe.6e7456d6.JPG";